import { render, staticRenderFns } from "./ProfileApproval.vue?vue&type=template&id=37a10f43"
import script from "./ProfileApproval.vue?vue&type=script&lang=js"
export * from "./ProfileApproval.vue?vue&type=script&lang=js"
import style0 from "./ProfileApproval.vue?vue&type=style&index=0&id=37a10f43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports